'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _Object$keys = require('@babel/runtime-corejs3/core-js-stable/object/keys');
var _Object$getOwnPropertySymbols = require('@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols');
var _filterInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/filter');
var _Object$getOwnPropertyDescriptor = require('@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor');
var _Object$getOwnPropertyDescriptors = require('@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors');
var _extends = require('@babel/runtime-corejs3/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime-corejs3/helpers/objectWithoutProperties');
var _defineProperty = require('@babel/runtime-corejs3/helpers/defineProperty');
var React = require('react');
var input = require('baseui/input');
var baseui = require('baseui');
var inlineStyleExpandShorthand = require('inline-style-expand-shorthand');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _Object$keys__default = /*#__PURE__*/_interopDefaultLegacy(_Object$keys);
var _Object$getOwnPropertySymbols__default = /*#__PURE__*/_interopDefaultLegacy(_Object$getOwnPropertySymbols);
var _filterInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_filterInstanceProperty);
var _Object$getOwnPropertyDescriptor__default = /*#__PURE__*/_interopDefaultLegacy(_Object$getOwnPropertyDescriptor);
var _Object$getOwnPropertyDescriptors__default = /*#__PURE__*/_interopDefaultLegacy(_Object$getOwnPropertyDescriptors);
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _excluded = ["overrides"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys__default["default"](object); if (_Object$getOwnPropertySymbols__default["default"]) { var symbols = _Object$getOwnPropertySymbols__default["default"](object); enumerableOnly && (symbols = _filterInstanceProperty__default["default"](symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor__default["default"](object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : _Object$getOwnPropertyDescriptors__default["default"] ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors__default["default"](source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor__default["default"](source, key)); }); } return target; }
var inputOverrides = {
  Root: {
    style: function style(_ref) {
      var $theme = _ref.$theme,
          $isFocused = _ref.$isFocused,
          $disabled = _ref.$disabled,
          $isReadOnly = _ref.$isReadOnly,
          $error = _ref.$error,
          $positive = _ref.$positive,
          $adjoined = _ref.$adjoined,
          $size = _ref.$size,
          $required = _ref.$required,
          $position = _ref.$position,
          $hasIconTrailing = _ref.$hasIconTrailing;
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
        borderTopLeftRadius: '5px',
        borderBottomLeftRadius: '5px',
        borderTopRightRadius: '5px',
        borderBottomRightRadius: '5px'
      }, getRootBorder($disabled, $isFocused, $error, $positive, $theme)), getRootColors($disabled, $isFocused, $error, $positive, $theme)), getFont($size, $theme)), getRootPadding($adjoined, $size, $theme.direction, $hasIconTrailing));
    }
  },
  Input: {
    style: function style(_ref2) {
      var $theme = _ref2.$theme,
          $isFocused = _ref2.$isFocused,
          $disabled = _ref2.$disabled,
          $isReadOnly = _ref2.$isReadOnly,
          $error = _ref2.$error,
          $positive = _ref2.$positive,
          $adjoined = _ref2.$adjoined,
          $size = _ref2.$size,
          $required = _ref2.$required,
          $position = _ref2.$position,
          $hasIconTrailing = _ref2.$hasIconTrailing;
      return _objectSpread(_objectSpread({}, getInputPadding($size, $isFocused, $disabled, $error, $positive, $isReadOnly, $adjoined, $theme.direction, $hasIconTrailing)), getFont($size, $theme));
    }
  },
  EndEnhancer: {
    style: function style(_ref3) {
      var $theme = _ref3.$theme,
          $isFocused = _ref3.$isFocused,
          $disabled = _ref3.$disabled,
          $error = _ref3.$error,
          $positive = _ref3.$positive,
          $adjoined = _ref3.$adjoined,
          $size = _ref3.$size,
          $required = _ref3.$required,
          $position = _ref3.$position;
      return _objectSpread(_objectSpread({}, getInputEnhancerPadding($size, false)), getInputEnhancerColors($disabled, $isFocused, $error, $positive, $theme));
    }
  },
  StartEnhancer: {
    style: function style(_ref4) {
      var $theme = _ref4.$theme,
          $isFocused = _ref4.$isFocused,
          $disabled = _ref4.$disabled,
          $error = _ref4.$error,
          $positive = _ref4.$positive,
          $adjoined = _ref4.$adjoined,
          $size = _ref4.$size,
          $required = _ref4.$required,
          $position = _ref4.$position;
      return _objectSpread(_objectSpread({}, getInputEnhancerPadding($size, true)), getInputEnhancerColors($disabled, $isFocused, $error, $positive, $theme));
    }
  },
  MaskToggleButton: {
    style: {
      marginRight: '-8px'
    }
  }
};
var Input = /*#__PURE__*/React__default["default"].forwardRef(function (props, ref) {
  var overrides = props.overrides,
      rest = _objectWithoutProperties__default["default"](props, _excluded);

  return /*#__PURE__*/React__default["default"].createElement(input.Input, _extends__default["default"]({}, rest, {
    overrides: baseui.mergeOverrides(inputOverrides, overrides),
    inputRef: ref
  }));
});

function getRootBorder($disabled, $isFocused, $error) {
  var $positive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var theme = arguments.length > 4 ? arguments[4] : undefined;

  if ($disabled) {
    return inlineStyleExpandShorthand.expand({
      borderWidth: '1px'
    });
  }

  if ($isFocused) {
    return inlineStyleExpandShorthand.expand({
      borderWidth: '2px'
    });
  }

  if ($error) {
    return inlineStyleExpandShorthand.expand({
      borderWidth: '1px'
    });
  }

  if ($positive) {
    return inlineStyleExpandShorthand.expand({
      borderWidth: '2px'
    });
  }

  return inlineStyleExpandShorthand.expand({
    borderWidth: '1px'
  });
}

function getRootColors($disabled, $isFocused, $error, $positive, theme) {
  var customTheme = theme;

  if ($disabled) {
    return {
      borderLeftColor: customTheme.colors.gray400,
      borderRightColor: customTheme.colors.gray400,
      borderTopColor: customTheme.colors.gray400,
      borderBottomColor: customTheme.colors.gray400,
      backgroundColor: customTheme.colors.inputFillDisabled
    };
  }

  if ($isFocused) {
    return {
      borderLeftColor: customTheme.colors.borderSelected,
      borderRightColor: customTheme.colors.borderSelected,
      borderTopColor: customTheme.colors.borderSelected,
      borderBottomColor: customTheme.colors.borderSelected,
      backgroundColor: customTheme.colors.inputFillActive
    };
  }

  if ($error) {
    return {
      borderLeftColor: customTheme.colors.inputBorderError,
      borderRightColor: customTheme.colors.inputBorderError,
      borderTopColor: customTheme.colors.inputBorderError,
      borderBottomColor: customTheme.colors.inputBorderError,
      backgroundColor: customTheme.colors.inputFillError
    };
  }

  if ($positive) {
    return {
      borderLeftColor: customTheme.colors.inputBorderPositive,
      borderRightColor: customTheme.colors.inputBorderPositive,
      borderTopColor: customTheme.colors.inputBorderPositive,
      borderBottomColor: customTheme.colors.inputBorderPositive,
      backgroundColor: customTheme.colors.inputFillPositive
    };
  }

  return {
    borderLeftColor: customTheme.colors.inputBorder,
    borderRightColor: customTheme.colors.inputBorder,
    borderTopColor: customTheme.colors.inputBorder,
    borderBottomColor: customTheme.colors.inputBorder,
    backgroundColor: customTheme.colors.inputFill
  };
}

function getRootPadding(adjoined, size, direction, hasIconTrailing) {
  var ifLeftPad = adjoined === input.ADJOINED.both || adjoined === input.ADJOINED.left && direction !== 'rtl' || adjoined === input.ADJOINED.right && direction === 'rtl' || hasIconTrailing && direction === 'rtl';
  var ifRightPad = adjoined === input.ADJOINED.both || adjoined === input.ADJOINED.right && direction !== 'rtl' || adjoined === input.ADJOINED.left && direction === 'rtl' || hasIconTrailing && direction !== 'rtl';

  if (size === 'compact') {
    return {
      paddingLeft: ifLeftPad ? '13px' : '0px',
      paddingRight: ifRightPad ? '13px' : '0px'
    };
  }

  return {
    paddingLeft: ifLeftPad ? '15px' : '0px',
    paddingRight: ifRightPad ? '15px' : '0px'
  };
}

function getInputPadding(size, $isFocused, $disabled, $error, $positive, $isReadOnly, adjoined, direction, hasIconTrailing) {
  var _SIZE$mini$SIZE$compa;

  var ifLeftPad = adjoined === input.ADJOINED.both || adjoined === input.ADJOINED.left && direction !== 'rtl' || adjoined === input.ADJOINED.right && direction === 'rtl' || hasIconTrailing && direction === 'rtl';
  var ifRightPad = adjoined === input.ADJOINED.both || adjoined === input.ADJOINED.right && direction !== 'rtl' || adjoined === input.ADJOINED.left && direction === 'rtl' || hasIconTrailing && direction !== 'rtl';
  return (_SIZE$mini$SIZE$compa = {}, _defineProperty__default["default"](_SIZE$mini$SIZE$compa, input.SIZE.mini, {
    paddingTop: '6px',
    paddingBottom: '6px',
    paddingLeft: '10px',
    paddingRight: '10px'
  }), _defineProperty__default["default"](_SIZE$mini$SIZE$compa, input.SIZE.compact, {
    paddingTop: '5px',
    paddingBottom: '5px',
    paddingLeft: ifLeftPad ? '10px' : '13px',
    paddingRight: ifRightPad ? '10px' : '13px'
  }), _defineProperty__default["default"](_SIZE$mini$SIZE$compa, input.SIZE.default, {
    paddingTop: '7px',
    paddingBottom: '7px',
    paddingLeft: ifLeftPad ? '12px' : '15px',
    paddingRight: ifRightPad ? '12px' : '15px'
  }), _defineProperty__default["default"](_SIZE$mini$SIZE$compa, input.SIZE.large, {
    paddingTop: '10px',
    paddingBottom: '10px',
    paddingLeft: '14px',
    paddingRight: '14px'
  }), _SIZE$mini$SIZE$compa)[size];
}

function getFont(size, theme) {
  var customTheme = theme;

  switch (size) {
    case input.SIZE.mini:
      return {
        fontSize: '10px',
        lineHeight: '14px',
        fontWeight: 'normal'
      };

    case input.SIZE.compact:
      return {
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: 'normal'
      };

    case input.SIZE.large:
      return {
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 'normal'
      };

    default:
      return customTheme.typography.Body1;
  }
} // just disable all enhance padding


function getInputEnhancerPadding($size, isStart) {
  return {
    paddingLeft: 0,
    paddingRight: 0
  };
}

function getInputEnhancerColors($disabled, $isFocused, $error, $positive, theme) {
  var customTheme = theme;

  if ($disabled) {
    return {
      color: customTheme.colors.gray400,
      backgroundColor: customTheme.colors.inputFillDisabled
    };
  }

  if ($isFocused) {
    return {
      color: customTheme.colors.borderSelected,
      backgroundColor: customTheme.colors.inputFillActive
    };
  }

  if ($error) {
    return {
      color: customTheme.colors.inputBorderError,
      backgroundColor: customTheme.colors.inputFillError
    };
  }

  if ($positive) {
    return {
      color: customTheme.colors.inputBorderPositive,
      backgroundColor: customTheme.colors.inputFillPositive
    };
  }

  return {
    color: customTheme.colors.inputBorder,
    backgroundColor: customTheme.colors.inputFill
  };
}

exports.Input = Input;
